import { Link } from "react-router-dom";

const STATS = [
  { value: "16", label: "剧集集数", suffix: "集" },
  { value: "6", label: "剧情解析", suffix: "篇" },
  { value: "8", label: "角色档案", suffix: "位" },
  { value: "6", label: "影视资讯", suffix: "条" },
];

const SCOPES = [
  {
    icon: "ri-book-open-line",
    title: "剧情深度解读",
    desc: "从主线脉络到支线暗线，逐集梳理关键情节与伏笔回收。",
  },
  {
    icon: "ri-user-3-line",
    title: "角色背景分析",
    desc: "主要角色的动机、成长与关系网，配合同期演员信息。",
  },
  {
    icon: "ri-newspaper-line",
    title: "影视资讯速递",
    desc: "收视动态、幕后花絮、主创专访与官方公告一网打尽。",
  },
];

export default function SiteIntro() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-600">About This Site</p>
          <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950">
            关于《我妻子的一切》内容站
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            本站专注于电视剧《我妻子的一切》的影视内容分享，面向喜欢该剧的观众、影视内容爱好者及剧集研究者。
            我们用结构化的方式整理剧情、角色与资讯，帮助你在追剧之外，获得更完整的观看体验与更深入的解读视角。
          </p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {SCOPES.map((scope) => (
              <div key={scope.title} className="rounded-md border border-background-200 bg-background-50 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${scope.icon} text-lg`} />
                </span>
                <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-900">
                  {scope.title}
                </h3>
                <p className="mt-1.5 text-xs leading-6 text-foreground-500">{scope.desc}</p>
              </div>
            ))}
          </div>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-700 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-800"
          >
            了解更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-1">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="rounded-md border border-background-200 bg-background-50 p-4"
            >
              <div className="flex items-baseline gap-1">
                <span className="font-heading text-3xl font-bold text-primary-700">{stat.value}</span>
                <span className="text-xs text-foreground-400">{stat.suffix}</span>
              </div>
              <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}